import { type adminGigApplicationHooks, adminGigApplicationListParams } from "api/clients/admin/applications";
import { route } from "react-router-typesafe-routes";
import { zod } from "react-router-typesafe-routes/zod";
import * as R from "remeda";
import { z } from "zod";

type CertificationRequestQueryPayload = NonNullable<
  Parameters<typeof adminGigApplicationHooks.getKeyByAlias<"getApplications">>[1]
>["queries"];

type RequestParams = NonNullable<CertificationRequestQueryPayload>;
type SearchParamsTransformed = Required<{
  [key in keyof RequestParams]: z.ZodType<RequestParams[key]>;
}>;

export const applicationHistoryRouteParams = route({
  searchParams: {
    applicationParams: zod(
      z.object({
        ...(R.mapToObj(adminGigApplicationListParams, (param) => [
          param.name,
          param.schema,
        ]) as SearchParamsTransformed),
        // make required
        page: z.number(),
        page_size: z.number(),
      }),
    ).default({ ordering: "-gig__start_time", page: 1, page_size: 25 }),
  },
});
